import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient as baseApiClient } from '#/api/client.tsx';
import { mutationNotif } from '#/utils/mutationNotif';
import { ENROLLMENT_QUERY_NAMESPACE } from './enrollmentsHooks';
import type { Enrollment, PayIntervalValue } from '../model';

const enrollmentsApiClient = baseApiClient.create({
  baseURL: `${import.meta.env.VITE_BASE_URL}/cockpit/auto-pay`,
});

export type UpdateEnrollmentBody = {
  payInterval: PayIntervalValue;
};

export type UpdateEnrollmentResponse = {
  id: Enrollment['id'];
};

export const updateEtcEnrollment = (
  enrollmentId: Enrollment['id'],
  body: UpdateEnrollmentBody,
) => {
  return enrollmentsApiClient
    .put<{
      data: UpdateEnrollmentResponse;
    }>(`/etc-auto-pay-enrollments/${enrollmentId}`, body)
    .then((res) => res.data.data);
};

export function useUpdateEtcEnrollment() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      enrollmentId,
      payInterval,
    }: {
      enrollmentId: Enrollment['id'];
      payInterval: PayIntervalValue;
    }) => updateEtcEnrollment(enrollmentId, { payInterval }),
    onMutate: ({ enrollmentId }) => {
      mutationNotif.loading(enrollmentId, {
        title: '編輯查繳週期',
        message: '更新中...',
      });
      return { notifId: enrollmentId };
    },
    onSuccess: (_, __, context) => {
      queryClient.invalidateQueries({
        queryKey: [ENROLLMENT_QUERY_NAMESPACE, 'list'],
      });
      if (!context?.notifId) return;
      mutationNotif.toSuccess(context.notifId, '查繳週期編輯成功');
    },
    onError: (_, __, context) => {
      if (!context?.notifId) return;
      mutationNotif.toError(context.notifId, '失敗請稍後再試');
    },
  });
}
